import { getUnitTitle } from '../../../../components/society/RegisterUnitList/helpers'
import { capitalize } from '../../../../helpers/string'
import { ISocietyEntranceModel } from '../../../../interfaces/models/society-entrance.interfaces'
import { IUnitModel } from '../../../../interfaces/models/units.interfaces'
import { NBinder } from '../../../../interfaces/services/binder.interfaces'

export type BinderType = {
  unitId: string
  function?: () => void
  adress: string
  aptNumber: string
  floor: number
  fileCount?: number
  folderCount?: number
  publishedAt?: string | null
}

export const mapUnitToBinderType = (
  unit: IUnitModel,
  societyEntrences?: ISocietyEntranceModel[],
  binderSummary?: NBinder.NGetAllBinders.IBinderSummary
): BinderType => {
  const entrance = societyEntrences?.find(
    (_entrance) => _entrance._id === unit.entranceId
  )
  return {
    unitId: unit._id,
    adress: entrance?.addressStreet ? capitalize(entrance.addressStreet) : '',
    aptNumber: getUnitTitle(unit),
    floor: unit.floor ?? 0,
    fileCount: binderSummary?.fileCount ?? 0,
    folderCount: binderSummary?.folderCount ?? 0,
    publishedAt: binderSummary?.publishedAt ?? null,
  }
}
